import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import logo1  from "@assets/logos_extracted/1.png";
import logo2  from "@assets/logos_extracted/2.png";
import logo3  from "@assets/logos_extracted/3.png";
import logo4  from "@assets/logos_extracted/4.png";
import logo5  from "@assets/logos_extracted/5.png";
import logo6  from "@assets/logos_extracted/6.png";
import logo7  from "@assets/logos_extracted/7.png";
import logo8  from "@assets/logos_extracted/8.png";
import logo9  from "@assets/logos_extracted/9.png";
import logo10 from "@assets/logos_extracted/10.png";
import logo11 from "@assets/logos_extracted/11.png";
import logo12 from "@assets/logos_extracted/12.png";
import logo13 from "@assets/logos_extracted/13.png";
import logo14 from "@assets/logos_extracted/14.png";
import logo15 from "@assets/logos_extracted/15.png";
import logo16 from "@assets/logos_extracted/16.png";
import logo17 from "@assets/logos_extracted/17.png";
import logo18 from "@assets/logos_extracted/18.png";
import logo19 from "@assets/logos_extracted/19.png";
import logo20 from "@assets/Untitled_design_(24)_1773076880991.png";
import logo21 from "@assets/Untitled_design_(25)_1773077218464.png";

const baseCasinos = [
  { id: 1,  name: "OnlySpins",      logo: logo1,  bonus: "Bonus až 12 500 Kč + 200 FS",  url: "https://ons.lynmonkel.com/?mid=279656_1882080" },
  { id: 2,  name: "Allyspin",       logo: logo2,  bonus: "Bonus až 25 000 Kč + 200 FS",  url: "https://all.monvaki.com/?mid=282906_1667056" },
  { id: 3,  name: "Legiano",        logo: logo3,  bonus: "Bonus až 12 500 Kč + 200 FS",  url: "https://lgno.monvaki.com/?mid=282906_1666929" },
  { id: 4,  name: "Bassbet",        logo: logo4,  bonus: "Bonus až 12 500 Kč + 200 FS",  url: "https://bsbt.fynkelto.com/?mid=279656_1645822" },
  { id: 5,  name: "FastSlots",      logo: logo5,  bonus: "Bonus až 125 000 Kč + 50 FS",  url: "https://record.discasinoaffiliates.com/_kTMXKwmZsM88TL4kmJ7MEGNd7ZgqdRLk/1/?pg=1" },
  { id: 6,  name: "Spinanga",       logo: logo6,  bonus: "Bonus až 12 500 Kč + 200 FS",  url: "https://spng.fynkelto.com/?mid=279656_1645837" },
  { id: 7,  name: "Rabona",         logo: logo7,  bonus: "Bonus až 12 500 Kč + 200 FS",  url: "https://rbn.fynkelto.com/?mid=279656_1645828" },
  { id: 8,  name: "Casinia",        logo: logo8,  bonus: "Bonus až 12 500 Kč + 200 FS",  url: "https://csn.fynkelto.com/?mid=279656_1645835" },
  { id: 9,  name: "Stone Vegas",    logo: logo9,  bonus: "Bonus až 12 500 Kč + 200 FS",  url: "https://stnvgs.fynkelto.com/?mid=308616_1816138" },
  { id: 10, name: "Golden Panda",   logo: logo10, bonus: "Bonus až 12 500 Kč + 10% CB",  url: "https://record.discasinoaffiliates.com/_kTMXKwmZsM98YAuMxhPI-WNd7ZgqdRLk/1/?pg=1" },
  { id: 11, name: "Instant Casino", logo: logo11, bonus: "Bonus až 185 000 Kč + 50 FS",  url: "https://record.discasinoaffiliates.com/_kTMXKwmZsM-u11z-n_bVh2Nd7ZgqdRLk/1/?pg=1" },
  { id: 12, name: "Boaboa",         logo: logo12, bonus: "Bonus až 12 500 Kč + 200 FS",  url: "https://bbaw.monvaki.com/?mid=282906_1667067" },
  { id: 13, name: "Alf Casino",     logo: logo13, bonus: "Bonus až 20 000 Kč + 300 FS",  url: "https://alcw.monvaki.com/?mid=282906_1667062" },
  { id: 14, name: "Cadoola",        logo: logo14, bonus: "Bonus až 12 500 Kč + 200 FS",  url: "https://cadw.monvaki.com/?mid=282906_1667064" },
  { id: 15, name: "Bankonbet",      logo: logo15, bonus: "Bonus až 12 500 Kč + 200 FS",  url: "https://bnkw.monvaki.com/?mid=282906_1667060" },
  { id: 16, name: "Wazamba",        logo: logo16, bonus: "Bonus až 12 500 Kč + 200 FS",  url: "https://wzbw.monvaki.com/?mid=282906_1667059" },
  { id: 17, name: "SPINiT",         logo: logo17, bonus: "Bonus až 12 500 Kč + 200 FS",  url: "https://swp.fynkelto.com/?mid=279656_1645821" },
  { id: 18, name: "SG Casino",      logo: logo18, bonus: "Bonus až 20 000 Kč + 250 FS",  url: "https://sgc.monvaki.com/?mid=282906_1667053" },
  { id: 19, name: "Librabet",       logo: logo19, bonus: "Bonus až 12 500 Kč + 200 FS",  url: "https://lrb.fynkelto.com/?mid=279656_1645829" },
  { id: 20, name: "Nomini",         logo: logo20, bonus: "Bonus až 12 500 Kč + 200 FS",  url: "https://nmn.fynkelto.com/?mid=279656_1645825" },
  { id: 21, name: "Wyns",           logo: logo21, bonus: "Bonus až 12 500 Kč + 200 FS",  url: "https://wns.fynkelto.com/?mid=311317_1933451" },
];

function shuffle<T>(arr: T[]): T[] {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

const TOTAL = baseCasinos.length;
const CARD_H = 92;
const GAP = 14;
const SLOT = CARD_H + GAP;
const VISIBLE = 3;
const WINDOW_H = VISIBLE * CARD_H + (VISIBLE - 1) * GAP;

function CarouselCard({ casino, isFirstVisible }: { casino: typeof baseCasinos[0]; isFirstVisible?: boolean }) {
  return (
    <div
      className="carousel-card"
      style={{
        height: `${CARD_H}px`,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        gap: "16px",
        padding: "16px",
        borderRadius: "12px",
        cursor: "pointer",
      }}
      data-testid={`carousel-casino-${casino.id}`}
    >
      <div style={{ width: 60, height: 60, borderRadius: 8, flexShrink: 0, overflow: "hidden" }}>
        <img src={casino.logo} alt={casino.name} className="w-full h-full object-cover" loading={isFirstVisible ? "eager" : "lazy"} />
      </div>
      <div style={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }}>
        <span className="text-white font-bold text-sm">{casino.name}</span>
        <span className="text-white/55 text-xs font-medium mt-0.5">{casino.bonus}</span>
      </div>
      <a href={casino.url} target="_blank" rel="sponsored noopener noreferrer">
        <Button
          size="sm"
          className="hraj-btn font-bold text-xs px-6"
          style={{ background: "#ffffff", color: "#003da5" }}
          data-testid={`button-hraj-carousel-${casino.id}`}
        >
          Hraj
        </Button>
      </a>
    </div>
  );
}

export function Hero() {
  const shuffled = useMemo(() => shuffle(baseCasinos), []);
  const [startIdx, setStartIdx] = useState(0);
  const [sliding, setSliding] = useState(false);
  const pausedRef = useRef(false);
  const slidingRef = useRef(false);

  const advance = useCallback(() => {
    if (pausedRef.current) return;
    slidingRef.current = true;
    setSliding(true);
  }, []);

  const handleTransitionEnd = useCallback((e: React.TransitionEvent<HTMLDivElement>) => {
    if (e.propertyName !== "transform" || e.target !== e.currentTarget) return;
    slidingRef.current = false;
    setSliding(false);
    setStartIdx(i => (i + 1) % TOTAL);
  }, []);

  useEffect(() => {
    const id = setInterval(advance, 4500);
    return () => clearInterval(id);
  }, [advance]);

  const trackCasinos = [0, 1, 2, 3].map(offset => shuffled[(startIdx + offset) % TOTAL]);

  return (
    <section className="relative pt-16 overflow-hidden" data-testid="section-hero">
      <div
        className="absolute inset-0 z-0"
        style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}
      />
      <div
        className="absolute inset-0 z-0 opacity-5"
        style={{
          backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
          backgroundSize: "40px 40px",
        }}
      />
      <div
        className="absolute top-0 right-0 w-80 h-80 opacity-10 z-0"
        style={{ background: "radial-gradient(circle, #0060e6 0%, transparent 70%)" }}
      />

      <div className="relative z-10 max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-14 sm:py-16">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div className="space-y-5">
            <h1 className="text-4xl sm:text-5xl font-black text-white leading-snug">
              České online casino
            </h1>
            <p className="text-white/90 text-xl font-semibold">
              Nejlepší stránky s ověřenou reputací
            </p>
            <p className="text-white/65 text-base leading-relaxed max-w-lg">
              TOP online casino jako nástroj pro výběr nejlepší platformy pro hraní. Kritéria hodnocení herní platformy. Vyberte si online casino real money pomocí našeho žebříčku.
            </p>
            <div className="flex flex-wrap gap-3 pt-1">
              <a
                href="#zebricek"
                data-testid="button-hero-primary"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("zebricek")?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                <Button
                  size="default"
                  className="hraj-btn font-bold gap-2"
                  style={{ background: "#ffffff", color: "#003da5" }}
                >
                  Zobrazit žebříčky
                  <ArrowRight className="hraj-arrow w-4 h-4" />
                </Button>
              </a>
              <a href="/kasina" data-testid="button-hero-secondary">
                <Button
                  size="default"
                  variant="outline"
                  className="hraj-btn border-white/30 text-white font-semibold"
                  style={{ background: "rgba(255,255,255,0.08)", backdropFilter: "blur(8px)" }}
                >
                  Přečíst recenze
                </Button>
              </a>
            </div>
          </div>

          <div className="lg:hidden" data-testid="hero-mobile-top3">
            <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-3">
              Top 3 kasina
            </p>
            <div className="flex gap-3">
              {baseCasinos.slice(0, 3).map((casino, idx) => (
                <a
                  key={casino.id}
                  href={casino.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 flex flex-col items-center gap-2 p-3 rounded-xl"
                  style={{ background: "rgba(255,255,255,0.08)", backdropFilter: "blur(8px)" }}
                  data-testid={`mobile-top-casino-${idx}`}
                >
                  <div className="w-14 h-14 rounded-xl overflow-hidden flex-shrink-0">
                    <img src={casino.logo} alt={casino.name} className="w-full h-full object-cover" loading={idx === 0 ? "eager" : "lazy"} />
                  </div>
                  <span className="text-white font-bold text-xs text-center leading-tight">{casino.name}</span>
                  <span className="text-white/50 text-[10px] text-center leading-tight">{casino.bonus}</span>
                </a>
              ))}
            </div>
          </div>

          <div className="hidden lg:block">
            <div className="flex items-center justify-between mb-3">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold">
                Naše oblíbená kasina
              </p>
              <div className="flex items-center gap-1.5">
                <span className="relative inline-flex h-1.5 w-1.5">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
                  <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-green-400" />
                </span>
                <span className="text-white/45 text-xs font-medium">Denně aktualizováno</span>
              </div>
            </div>

            <div
              style={{ height: `${WINDOW_H}px`, overflow: "hidden", position: "relative" }}
              data-testid="hero-carousel-casinos"
              onMouseEnter={() => { pausedRef.current = true; }}
              onMouseLeave={() => { pausedRef.current = false; }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: `${GAP}px`,
                  transform: `translateY(${sliding ? -SLOT : 0}px)`,
                  transition: sliding ? "transform 0.65s cubic-bezier(0.4, 0, 0.2, 1)" : "none",
                }}
                onTransitionEnd={handleTransitionEnd}
              >
                {trackCasinos.map((casino, idx) => (
                  <CarouselCard key={casino.id} casino={casino} isFirstVisible={idx < VISIBLE} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative z-10">
        <svg viewBox="0 0 1440 44" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full block" preserveAspectRatio="none" style={{ display: "block", verticalAlign: "bottom", height: "44px" }}>
          <rect x="0" y="40" width="1440" height="4" fill="white" />
          <path d="M0 44L1440 44L1440 0C1200 35 720 40 0 0L0 44Z" fill="white" />
        </svg>
      </div>
    </section>
  );
}
